import { render, staticRenderFns } from "./issue-codes-select.vue?vue&type=template&id=48b38417&scoped=true&"
import script from "./issue-codes-select.vue?vue&type=script&lang=js&"
export * from "./issue-codes-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b38417",
  null
  
)

export default component.exports